const GtagSend = (options) => {

    if(options && options.page_title){
        window.gtag('config', 'G-C4P7719KTG', {
            'page_path': window.location.pathname,
            'page_title' : options.page_title
          });
    }
}
export default GtagSend;